<template>
  <v-app>
    <v-app-bar app color="dark" dark>
      <v-toolbar-title>
        Layout Labelling
        <span class="text-caption ml-3" style="opacity:0.75">Consent</span>
      </v-toolbar-title>
    </v-app-bar>
    <v-main>
      <v-container>
        <v-row justify="center">
          <v-col cols="12" md="9">
            <v-card class="pa-6" v-if="!declined">
              <v-card-title class="text-h5">Study Information and Consent</v-card-title>
              <v-card-text class="text-body-1">
                <p>
                  This research looks at how different visual layouts of network diagrams affect
                  people's ability to find paths between items in a diagram. You will be shown a
                  series of diagrams and asked short questions about them, such as how many steps
                  connect two highlighted points. The study takes about 30 to 40 minutes.
                </p>
                <p>
                  This study has been determined <b>exempt</b> by the Northeastern University
                  Institutional Review Board (IRB case 26-04-31).
                </p>
                <p>
                  Your participation is completely voluntary. You may stop at any time, for any
                  reason, without penalty. Your responses will be recorded and will not be linked
                  to your name. Your data may be used and shared, in deidentified, aggregate form,
                  for research purposes, including presentations or publications.
                </p>
                <p>
                  There are no significant risks beyond the normal eye strain that can come from
                  screen based tasks.
                  <b>
                    This study includes a $6 base payment (30 minutes, about $12 per hour) plus a
                    performance bonus of up to $1.80, based on accuracy and careful, attentive
                    responding.
                  </b>
                  Bonuses are ranked relative to other participants: the top 20 percent by
                  accuracy receive $1.80 and the next 30 percent receive $1.20.
                  Participants who do not pass the brief screening are paid for the time spent on
                  training.
                </p>
                <p>
                  Questions? Contact Dr. Yifan Hu (yif.hu@northeastern.edu) or Shreya Sundaram
                  (sundaram.shr@northeastern.edu).
                </p>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text color="primary" :loading="loading" @click="decline">
                  I do not wish to continue
                </v-btn>
                <v-btn color="primary" large :loading="loading" @click="agree">
                  I agree, continue
                </v-btn>
              </v-card-actions>
            </v-card>
            <v-card class="pa-6" v-else>
              <v-card-title class="text-h5">Thank you</v-card-title>
              <v-card-text>
                Thanks for your time. No data has been recorded. Returning you to Prolific…
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import config from '@/config';
import prolificConfig from '@/config/prolific';

export default {
  name: 'Consent',
  data() {
    return {
      sessionId: this.$route.params.sessionId,
      loading: false,
      declined: false,
      completionUrl: prolificConfig.PROLIFIC_COMPLETION_URL,
    };
  },
  methods: {
    async agree() {
      if (this.loading) return;
      this.loading = true;
      try {
        await fetch(`${config.API_BASE_URL}/prolific/session/${this.sessionId}/consent/`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ consented: true }),
        });
        this.$router.replace(`/prolific/study/${this.sessionId}/video`);
      } catch (e) {
        console.error(e);
        this.loading = false;
      }
    },
    async decline() {
      if (this.loading) return;
      this.loading = true;
      this.declined = true;
      try {
        const resp = await fetch(`${config.API_BASE_URL}/prolific/session/${this.sessionId}/consent/`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ consented: false }),
        });
        const data = await resp.json();
        const url = data.prolific_completion_url || this.completionUrl;
        setTimeout(() => { window.location.href = url; }, 1800);
      } catch (e) {
        window.location.href = this.completionUrl;
      }
    },
  },
};
</script>
